import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Methodology from "../views/Methodology.vue";
import ForensicDiagnosis from "../views/ForensicDiagnosis.vue";
import Repository from "../views/Repository.vue";
import store from "../store/index";
import { applySeo } from "../utils/seo";
import seo from "../seo/pages.json";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: seo.routes["/"]
  },
  {
    path: "/tablero",
    name: "Methodology",
    component: Methodology,
    meta: seo.routes["/tablero"]
  },
  {
    path: "/diagnostico-forense",
    name: "Forensic Diagnosis",
    component: ForensicDiagnosis,
    meta: seo.routes["/diagnostico-forense"]
  },
  {
    path: "/repositorio",
    name: "Repo",
    component: Repository,
    meta: seo.routes["/repositorio"]
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // Init map on route change
  store.state.selectedEntity = "";
  store.state.filterYears = store.state.initialYears;
  store.state.autocompleteVal = "";
  next();
});

router.afterEach(to => {
  applySeo({
    title: to.meta.title,
    description: to.meta.description,
    path: to.fullPath
  });
});

export default router;
